<template>
    <transition name="fade">
        <div class="garbage-qrcode" v-show="showQrcode">
            <div>
                <img src="/static/images/2500/qrcode.jpg">
                <h5>长按识别二维码</h5>
                <p>进入第三方垃圾分类查询小程序</p>
            </div>
            <i @click="$store.commit('GARBAGE_QRCODE', false)"></i>
        </div>
    </transition>
</template>

<script>
	export default {
		name: 'garbageQrcode',
		data () {
			return {

			}
		},
		computed: {
            showQrcode() {
                return this.$store.getters._ShowGarbageQrcode
            }
		}
	}
</script>

<style lang="scss" scoped>
	.garbage-qrcode {
        position: fixed;
        top: 0; bottom: 0; left: 0; right: 0;
        background-color: rgba(0, 0, 0, .3);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        & > div {
            width: j(600);
            height: j(860);
            background-color: #fff;
            border-radius: j(20);
            overflow: hidden;
            padding-top: j(100);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-direction: column;
            img {
                height: j(450);
                width: j(450);
                margin-bottom: j(100);
            }
            h5 {
                font-size: j(36);
                color:rgb(54, 60, 84);
                margin-bottom: j(20);
            }
            p {
                font-size: j(30);
            }
        }
        i {
            margin-top: j(60);
            height: j(80); width: j(80);
            background: url("/static/images/icon/close-circle.png") no-repeat;
            background-size: contain;
        }
    }

    .fade-enter-active, .fade-leave-active {
		transition: opacity .3s linear;
	}
	.fade-enter, .fade-leave-to{
		opacity: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/garbageQrcode.vue